import styles from '../../transfer-page/TransferPage.module.scss';
import checkBlc from 'assets/images/check-blc.svg';
import searchIcon from 'assets/images/search.svg';

import { commonActions, countryAction, beneficiaryActions } from '../../../stores/_actions';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import Label from '../../../constants/Label';
import Validator from '../common-functions';
import popClose from 'assets/images/pop-close.svg';
import { Link, useHistory, useLocation } from 'react-router-dom';
import popUpStyles from '../../components/popup/PopupModel.module.scss';
import { Items } from './Items';
import { beneficary } from 'stores/_reducer';
import { Dropdown } from '../../components/Dropdown/Dropdown';
const AddBeneficary = (props) => {
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const [bankOption, setBankOption] = useState('');
  const [inccodeType, setInccodeType] = useState('Select Code Type');
  const [inccodeTypeID, setInccodeTypeID] = useState('');
  const [setRelationItem, setRelation] = useState('Select Relationship');
  const [setBankItem, setBankName] = useState('Select Bank Name');
  const [setBranchItem, setBranchName] = useState('Select Branch Name');
  const [incCountry, setIncCountry] = useState('Select Country');
  const [typeDetails, setStylecodeType] = useState('');
  const [country, setStyleCountry] = useState('');
  const [relation, setRelationShip] = useState('');
  const [bank, setBank] = useState('');
  const [branch, setBranch] = useState('');
  const [incCurrency, setIncCurrency] = useState('Select Currency');
  const [currency, setStyleCurrency] = useState('');
  const [incservices, setIncservices] = useState('Select Service');
  const [services, setStyleServices] = useState('');
  const [incServiceProvider, setServiceProvider] = useState('Service Provider');
  const [incServiceProviderID, setServiceProviderID] = useState('');
  const [serviceProvider, setStyleServiceProvider] = useState('');
  const [incagent, setIncagent] = useState('Select Agent');
  const [agentCode, setAgentCode] = useState('');
  const [getAgentDetails, setStyleAgent] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [hide, setN] = useState(false);
  const [popupOk, setPopupOk] = useState(false);
  const [beneficiary, setBeneficiary] = useState({
    CustomerCode: userProfile?.CustomerCode,
    BenFirstName: '',
    BenfMName: '',
    BenLastName: '',
    BenfAddr1: '',
    BenfAddr2: '',
    BenfAddr3: '',
    BenfCountry: '',
    CurrencyCode: '',
    BenfIDType: '',
    BenfIDNum: '',
    Service: '',
    BenfBank: '',
    BenfBranch: '',
    AccountNo: '',
    BenfMobileNo: '',
    BankName: '',
    BranchName: '',
    CONTCODE: '',
    CORRORGCODE: '',
    SERVCODE: '',
    BicCode: '',
    Relationship: '',
    EmailId: '',
    Region: '',
    AccountType: '',
    Accountcurrency: '',
    DOB: '',
    BenfNationality: '',
  });
  const [payload, setPayload] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: userProfile?.CustomerCode,
      ServiceCode: '00001',
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  });
  const [branche, setBranches] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      BankCode: '00001',
    },
    Status: false,
    SessionID: null,
    IdType: null,
    FileType: null,
    Langcode: null,
  });

  const payloadForAllBanks = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: null,
      CountryCode: null,
      CurrCode: null,
      ServCode: null,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };

  const payloadForBankBranches = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {},
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(countryAction.getRemitCountry(payload));
    dispatch(commonActions.typeDetails());
    dispatch(beneficiaryActions.getRelationShip(payload));
    // dispatch(commonActions.branches(branche));
    // dispatch(beneficiaryActions.getBankBranch(payload2));
    dispatch(countryAction.clearCurrencyService());
  }, []);

  const selectCountryName = (event, items) => {
    setStyleCountry(!country);
    setIncCurrency('Select Currency');
    payload.Data['CurrencyCode'] = '';
    setIncservices('Select Service');
    payload.Data['CurrencyFlag'] = '';
    setIncCountry(
      (incCountry) => (
        ((payload.Data['CountryCode'] = items.ID), (payload.Data['mobileCode'] = items.Ccd), (payload.Data['Module'] = 'AddBen')),
        (incCountry = items.Description)
      )
    );
    dispatch(countryAction.getRemitCurrency(payload));
    setBankName('Select Bank Name');
    setBranchName('Select Branch Name');
    setBankOption('');
  };

  const selectCodeType = (event, items) => {
    setStylecodeType(!typeDetails);
    payload.Data['OtherDtlCode'] = items.ID;
    setInccodeType((inccodeType) => (inccodeType = items.Description));
    setInccodeTypeID((inccodeTypeID) => (inccodeTypeID = items.ID));
    setBeneficiary((beneficary) => ({ ...beneficary, CONTCODE: '' }));
    enterCode(null);
    // setBankName('Select Bank Name');
    // bankName = 'Select Bank Name';
    // setBranchName('Select Branch Name');
    // branchName = 'Select Branch Name';
  };
  const selectCurrencyName = (event, items) => {
    setStyleCurrency(!currency);
    setIncCurrency(
      (incCurrency) => (
        (payload.Data['CurrencyCode'] = items.ID), (payload.Data['CurrencyFlag'] = items.CurrencyFlagPath), (incCurrency = items.Description)
      )
    );
    setBankName('Select Bank Name');
    setBranchName('Select Branch Name');
    setBankOption(null);
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      BankName: '',
      BranchName: '',
      bankOption: '',
    }));
    setIncservices('Select Service');
    dispatch(commonActions.services(payload));
  };

  const selectServicesName = (event, items) => {
    setStyleServices(!services);
    setBankName('Select Bank Name');
    setBranchName('Select Branch Name');
    setBankOption(null);
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      BankName: '',
      BranchName: '',
      bankOption: '',
    }));
    setIncservices((incservices) => (incservices = items.Description));
    // setBankOption((bankOption) => {
    //   bankOption = '';
    // });
    setBeneficiary((beneficary) => ({ ...beneficary, SERVCODE: items.ID }));
    dispatch(commonActions.serviceProvider(payload));
  };
  const selectServiceProvider = (event, items) => {
    setStyleServiceProvider(!serviceProvider);
    setBankName('Select Bank Name');
    setBranchName('Select Branch Name');
    setBankOption(null);
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      BankName: '',
      BranchName: '',
      bankOption: '',
    }));
    setServiceProvider((incServiceProvider) => (incServiceProvider = items.Description));
    setServiceProviderID((incServiceProviderID) => (incServiceProviderID = items.ID));
    dispatch(commonActions.getAgentDetails(payload));
  };

  const selectAgentName = (event, items) => {
    setStyleAgent(!getAgentDetails);
    setIncagent((incagent) => (incagent = items.Description));
    setAgentCode((agentCode) => (agentCode = items.ID));
  };

  const selectRelationShip = (event, items) => {
    setRelationShip(!relation);
    setRelation((setRelationItem) => ((payload.Data['Relationship'] = items.ID), (setRelationItem = items.Description)));
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      Relationship: items.ID,
    }));
  };

  const selectBankLists = (event, items) => {
    setBank(!bank);
    setBranchName('Select Branch Name');
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      BranchName: '',
    }));
    branchName = '';
    if (bankOption === 'Bank Code') {
      setBankName((setBankItem) => ((payload.Data['BankName'] = items.OrgName), (setBankItem = items.OrgName)));
      setBeneficiary((beneficiary) => ({
        ...beneficiary,
        BankName: items.OrgCode,
      }));
    } else {
      setBankName((setBankItem) => ((payload.Data['BankName'] = items.Description), (setBankItem = items.Description)));
      setBeneficiary((beneficiary) => ({
        ...beneficiary,
        BankName: items.ID,
      }));
    }
    payloadForBankBranches.Data['CustomerCode'] = userProfile?.CustomerCode;
    payloadForBankBranches.Data['CountryCode'] = payload.Data['CountryCode'];
    payloadForBankBranches.Data['CurrCode'] = payload.Data['CurrencyCode'];
    payloadForBankBranches.Data['ServCode'] = beneficiary.SERVCODE;
    payloadForBankBranches.Data['BankCode'] = items.ID;
    dispatch(beneficiaryActions.getAllBankBranches(payloadForBankBranches));
  };

  const selectBranchLists = (event, items) => {
    setBranch(!branch);
    setBranchName((setBranchItem) => ((payload.Data['BranchName'] = items.BranchCode), (setBranchItem = items.BranchName)));
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      BranchName: items.BranchCode,
    }));
  };

  let bankDetail;
  useSelector((state) => {
    bankDetail = state.getBankBranch?.data;
    // beneficiary['BenfAddr1'] = (bankDetail && bankDetail[0].Address) || beneficiary.BenfAddr1;
    // beneficiary['BankName'] = (bankDetail && bankDetail[0].OrgName) || beneficiary.OrgName;
    // beneficiary['BranchName'] = (bankDetail && bankDetail[0].BranchName) || beneficiary.BranchName;
    beneficiary['BenfMobileNo'] = (bankDetail && bankDetail[0].phone) || beneficiary.BenfMobileNo;
  }, []);

  const enterCode = (value = null) => {
    payload.Data['OtherDtlValue'] = value || beneficiary.CONTCODE;
    dispatch(beneficiaryActions.getBankBranch(payload));
    if (bankDetail && bankDetail.length > 0) {
      setBeneficiary((beneficiary) => ({
        ...beneficiary,
        BankName: bankDetail && bankDetail[0].OrgName,
        BranchName: bankDetail && bankDetail[0].BranchName,
        BenfMobileNo: bankDetail && bankDetail[0].phone,
      }));
    }
  };

  const typeDetailsList = useSelector((state) => {
    return state.typeDetails?.data;
  });
  let countryList;
  useSelector((state) => {
    countryList = state.getRemitCountry?.data;
  });

  let relationList;
  let bankList;
  let branchList;
  let bankName;
  let bankCode;
  let branchCode;
  let branchName;
  useSelector((state) => {
    relationList = state.getRelationShip?.data;
    // branchList = state.branches?.data;
    if (bankOption === 'Bank Code' && state.getBankBranch?.data) {
      bankList = state.getBankBranch?.data;
      bankName = bankList[0].OrgName; // setBankName(bankList[0].OrgName);
      bankCode = bankList[0].OrgCode;
      branchName = bankList[0].BranchName; // setBranchName(bankList[0].BranchName);
      branchCode = bankList[0].BranchCode;
    }
    if (bankOption === 'Location Code' && state.getAllBanks.data) {
      bankList = state.getAllBanks?.data;
    }
    if (bankOption === 'Location Code' && state.getAllBankBranch.data) {
      branchList = state.getAllBankBranch?.data;
    }
  });

  let currencyList;
  useSelector((state) => {
    currencyList = state.getRemitCurrency?.data;
  });

  let servicesList;
  useSelector((state) => {
    servicesList = state.services?.data;
  });

  let serviceProviderList;
  useSelector((state) => {
    serviceProviderList = state.serviceProvider?.data;
  });
  let agentList;
  useSelector((state) => {
    agentList = state.getAgentDetails?.data;
  });

  const reqPayload = {
    Id: null,
    Message: null,
    CustomerCode: userProfile?.CustomerCode,
    Langcode: '0001',
    Data: {
      ServiceProvider: null,
      ServiceProviderName: null,
      Agent: null,
      AgentName: null,
      ServNo: null,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };
  let errorMsg = '';
  let errorAccountMsg = '';
  let errorAdd1Msg = '';
  let errorAdd2Msg = '';

  const hidePopup = () => {
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      errorMsg: '',
      errorAccountMsg: '',
      BenfBranch: '',
      BenfBank: '',
      BenFirstName: '',
      BenLastName: '',
      BenfMName: '',
      BenfMobileNo: '',
      BenfAddr1: '',
      BenfAddr2: '',
      BenfAddr3: '',
      CONTCODE: '',
      BankName: '',
      BranchName: '',
    }));
    setPopupOk(true);
    setRelation('Select Relationship');
    setBankName('Select Bank Name');
    setIncCountry('Select Country');
    setIncCurrency('Select Currency');
    setIncservices('Select Service');
    setServiceProvider('Service Provider');
    setIncagent('Select Agent');
    setInccodeType('Select Code Type');
    setInccodeTypeID('');
    setN(false);
    window.location.reload(false);
  };
  let errorMsgFirstName;
  let errorMsgLastName;
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'CONTCODE') {
      setBeneficiary((beneficiary) => ({ ...beneficiary, [name]: value }));
      enterCode(value);
    } else {
      if (name == 'BenFirstName') {
        setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsgFirstName: '' }));
        const checkNumber = Validator.nameValidate(value);
        if (checkNumber && value.replace(/\s/g, '') === '' && value) {
          errorMsgFirstName = 'Please enter valid First Name';
          if (!beneficiary.prevFirstName) {
            setBeneficiary((beneficiary) => ({ ...beneficiary, FirstName: value, errorMsgFirstName: errorMsgFirstName }));
          } else {
            setBeneficiary((beneficiary) => ({ ...beneficiary, FirstName: beneficiary.prevFirstName, errorMsgFirstName: errorMsgFirstName }));
            beneficiary.prevFirstName = value;
          }
        } else if (!checkNumber && value) {
          errorMsgFirstName = 'Please enter valid First Name';
          if (!beneficiary.prevFirstName) {
            setBeneficiary((beneficiary) => ({ ...beneficiary, FirstName: value, errorMsgFirstName: errorMsgFirstName }));
          } else {
            setBeneficiary((beneficiary) => ({ ...beneficiary, FirstName: beneficiary.prevFirstName, errorMsgFirstName: errorMsgFirstName }));
            return;
          }
        }
        beneficiary.prevFirstName = value;
      }
      if (name == 'BenLastName') {
        setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsgLastName: '' }));
        const checkNumber = Validator.nameValidate(value);
        if (checkNumber && value.replace(/\s/g, '') === '' && value) {
          errorMsgLastName = 'Please enter valid Last Name';
          if (!beneficiary.prevLastName) {
            setBeneficiary((beneficiary) => ({ ...beneficiary, LastName: value, errorMsgLastName: errorMsgLastName }));
          } else {
            setBeneficiary((beneficiary) => ({ ...beneficiary, LastName: beneficiary.prevLastName, errorMsgLastName: errorMsgLastName }));
            beneficiary.prevLastName = value;
          }
        } else if (!checkNumber && value) {
          errorMsgLastName = 'Please enter valid Last Name';
          if (!beneficiary.prevLastName) {
            setBeneficiary((beneficiary) => ({ ...beneficiary, LastName: value, errorMsgLastName: errorMsgLastName }));
          } else {
            setBeneficiary((beneficiary) => ({ ...beneficiary, LastName: beneficiary.prevLastName, errorMsgLastName: errorMsgLastName }));
            return;
          }
        }
        beneficiary.prevLastName = value;
      }
      if (name == 'BenfMobileNo') {
        setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsg: '' }));
        if (beneficiary.prevMobNo == '') setBeneficiary((beneficiary) => ({ ...beneficiary, [name]: value }));
        setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsg: '' }));
        const checkNumber = Validator.digitsOnly(value);
        if (!checkNumber && value) {
          errorMsg = 'Mobile Number should be Numeric';

          if (!beneficary.prevMobNo) {
            setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsg: errorMsg }));
          } else {
            setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsg: errorMsg }));
            return;
          }
          beneficiary.prevMobNo = value;
          return;
        }
        if (payload.Data['CountryCode'] == 'IN' && value.length > 10) {
          errorMsg = '';
          setBeneficiary((beneficiary) => ({ ...beneficiary, BenfMobileNo: beneficiary.prevMobNo }));
          setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsg: errorMsg }));
          return;
        } else if (payload.Data['CountryCode'] != 'IN' && value.length > 8) {
          errorMsg = '';
          setBeneficiary((beneficiary) => ({ ...beneficiary, BenfMobileNo: beneficiary.prevMobNo }));
          setBeneficiary((beneficiary) => ({ ...beneficiary, errorMsg: errorMsg }));
          return;
        }
        beneficiary.prevMobNo = value;
        beneficiary.BenfMobileNo = value;
        setBeneficiary((beneficiary) => ({ ...beneficiary, BenfMobileNo: value }));
      }
      if (name == 'AccountNo') {
        setBeneficiary((beneficiary) => ({ ...beneficiary, errorAccountMsg: '' }));
        const checkNumber = Validator.alphanumberic(value);
        if (!checkNumber && value) {
          errorAccountMsg = 'Account Number should be Alphanumeric';
          setBeneficiary((beneficiary) => ({ ...beneficiary, AccountNo: beneficiary.AccountNo }));
          setBeneficiary((beneficiary) => ({ ...beneficiary, errorAccountMsg: errorAccountMsg }));
          return;
        }
      }
      if (name == 'BenfAddr1') {
        setBeneficiary((beneficiary) => ({ ...beneficiary, errorAdd1Msg: '' }));
        setBeneficiary((beneficiary) => ({ ...beneficiary, [name]: value }));
        const checkNumber = Validator.addressValidator(value);
        if (checkNumber && value.replace(/\s/g, '') === '' && value) {
          errorAdd1Msg = 'Address 1 should be Alphanumeric';
          setBeneficiary((beneficiary) => ({ ...beneficiary, BenfAddr1: value, errorAdd1Msg: errorAdd1Msg }));
        } else if (!checkNumber && value) {
          errorAdd1Msg = 'Address 1 should be Alphanumeric';
          setBeneficiary((beneficiary) => ({ ...beneficiary, BenfAddr1: beneficiary.BenfAddr1 }));
          setBeneficiary((beneficiary) => ({ ...beneficiary, errorAdd1Msg: errorAdd1Msg }));
          return;
        }
      }
      if (name == 'BenfAddr2') {
        setBeneficiary((beneficiary) => ({ ...beneficiary, errorAdd2Msg: '' }));
        setBeneficiary((beneficiary) => ({ ...beneficiary, [name]: value }));
        const checkNumber = Validator.addressValidator(value);
        if (checkNumber && value.replace(/\s/g, '') === '' && value) {
          errorAdd2Msg = 'Address 2 should be Alphanumeric';
          setBeneficiary((beneficiary) => ({ ...beneficiary, BenfAddr2: value, errorAdd2Msg: errorAdd2Msg }));
        } else if (!checkNumber && value) {
          errorAdd2Msg = 'Address 2 should be Alphanumeric';
          setBeneficiary((beneficiary) => ({ ...beneficiary, BenfAddr2: beneficiary.BenfAddr2 }));
          setBeneficiary((beneficiary) => ({ ...beneficiary, errorAdd2Msg: errorAdd2Msg }));
          return;
        }
      }

      setBeneficiary((beneficiary) => ({ ...beneficiary, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setPopupOk(false);
    if (!payload.Data['CurrencyCode'] || !payload.Data['CountryCode']) {
      return;
    }
    if (incservices == 'CASH PICK UP') {
      if (
        beneficiary.BenfAddr1.replace(/\s/g, '') === '' ||
        beneficiary.BenfAddr2.replace(/\s/g, '') === '' ||
        beneficiary.Relationship.replace(/\s/g, '') === '' ||
        incServiceProviderID.replace(/\s/g, '') === '' ||
        agentCode.replace(/\s/g, '') === '' ||
        beneficiary.BenLastName.replace(/\s/g, '') === '' ||
        beneficiary.BenFirstName.replace(/\s/g, '') === '' ||
        beneficiary.BenfMobileNo.replace(/\s/g, '') === ''
      ) {
        return;
      }
    } else if (incservices == 'WALLET TRANSFER') {
      if (
        beneficiary.BenfAddr1.replace(/\s/g, '') === '' ||
        beneficiary.BenfAddr2.replace(/\s/g, '') === '' ||
        beneficiary.Relationship.replace(/\s/g, '') === '' ||
        beneficiary.BenLastName.replace(/\s/g, '') === '' ||
        beneficiary.BenFirstName.replace(/\s/g, '') === '' ||
        beneficiary.BenfMobileNo.replace(/\s/g, '') === ''
      ) {
        return;
      }
    } else {
      if (bankOption === 'Bank Code') {
        if (
          beneficiary.BenfAddr1.replace(/\s/g, '') === '' ||
          beneficiary.BenfAddr2.replace(/\s/g, '') === '' ||
          beneficiary.Relationship.replace(/\s/g, '') === '' ||
          branchName.replace(/\s/g, '') === '' ||
          bankName.replace(/\s/g, '') === '' ||
          beneficiary.AccountNo.replace(/\s/g, '') === '' ||
          beneficiary.BenLastName.replace(/\s/g, '') === '' ||
          beneficiary.BenFirstName.replace(/\s/g, '') === '' ||
          beneficiary.BenfMobileNo.replace(/\s/g, '') === ''
        ) {
          return;
        }
      } else {
        if (
          beneficiary.BenfAddr1.replace(/\s/g, '') === '' ||
          beneficiary.BenfAddr2.replace(/\s/g, '') === '' ||
          beneficiary.Relationship.replace(/\s/g, '') === '' ||
          beneficiary.BranchName.replace(/\s/g, '') === '' ||
          beneficiary.BranchName.replace(/\s/g, '') === 'Select Branch Name' ||
          beneficiary.BankName.replace(/\s/g, '') === '' ||
          beneficiary.BankName.replace(/\s/g, '') === 'Select Bank Name' ||
          beneficiary.AccountNo.replace(/\s/g, '') === '' ||
          beneficiary.BenLastName.replace(/\s/g, '') === '' ||
          beneficiary.BenFirstName.replace(/\s/g, '') === '' ||
          beneficiary.BenfMobileNo.replace(/\s/g, '') === ''
        ) {
          return;
        }
      }
    }
    reqPayload.Id = null;
    reqPayload.Message = null;
    reqPayload.CustomerCode = userProfile?.CustomerCode;
    reqPayload.Langcode = '0001';
    reqPayload.Data['Agent'] = agentCode;
    reqPayload.Data['AgentName'] = incagent === 'Select Agent' ? null : incagent;
    reqPayload.Data['ServiceProvider'] = incServiceProviderID;
    reqPayload.Data['ServiceProviderName'] = incServiceProvider === 'Service Provider' ? null : incServiceProvider;
    reqPayload.Data['CustomerCode'] = userProfile?.CustomerCode;
    reqPayload.Data['BenFirstName'] = beneficiary.BenFirstName;
    reqPayload.Data['BenfMName'] = beneficiary.BenfMName;
    reqPayload.Data['BenLastName'] = beneficiary.BenLastName;
    reqPayload.Data['BenfAddr1'] = beneficiary.BenfAddr1;
    reqPayload.Data['BenfAddr2'] = beneficiary.BenfAddr2;
    // reqPayload.Data['BenfBranch'] = beneficiary.BenfBranch || branchName;
    reqPayload.Data['BenfAddr3'] = beneficiary.BenfAddr3;
    reqPayload.Data['BenfCountry'] = payload.Data['CountryCode'];
    reqPayload.Data['CurrencyCode'] = payload.Data['CurrencyCode'];
    reqPayload.Data['CONTCODE'] = payload.Data['CountryCode'];
    reqPayload.Data['BenfIDType'] = agentCode;
    reqPayload.Data['BenfIDNum'] = beneficiary.BenfIDNum;
    reqPayload.Data['Service'] = incservices;
    reqPayload.Data['BenfBank'] = beneficiary.BankName || bankCode;
    reqPayload.Data['BenfBranch'] = beneficiary.BranchName || branchCode;
    reqPayload.Data['AccountNo'] = beneficiary.AccountNo;
    reqPayload.Data['BenfMobileNo'] = payload.Data['mobileCode'] + beneficiary.BenfMobileNo;
    reqPayload.Data['BenfBankName'] =
      incservices == 'Mobile Wallet' || incservices == 'CASH PICK UP'
        ? ''
        : (bankDetail && bankDetail[0]?.BankName) || payload.Data['BankName'] || bankName;
    reqPayload.Data['BenfBranchName'] =
      incservices == 'Mobile Wallet' || incservices == 'CASH PICK UP' ? '' : (bankDetail && bankDetail[0]?.BranchName) || setBranchItem;
    reqPayload.Data['BicCode'] =
      incservices == 'Mobile Wallet' || incservices == 'CASH PICK UP' || bankOption != 'Bank Code' ? '' : beneficiary.CONTCODE;
    reqPayload.Data['CORRORGCODE'] = bankDetail && bankDetail[0]?.OrgCode;
    reqPayload.Data['SERVCODE'] = beneficiary.SERVCODE;
    // reqPayload.Data['BicCode'] = bankOption === 'Bank Code' ? (inccodeType === 'Select Code Type' ? null : inccodeTypeID) : '';
    reqPayload.Data['Relationship'] = payload.Data['Relationship'];
    reqPayload.Data['EmailId'] = bankDetail && bankDetail[0]?.Email;
    reqPayload.Data['Region'] = beneficiary.Region;
    reqPayload.Data['AccountType'] = beneficiary.AccountType;
    reqPayload.Data['AccountCurrency'] = userProfile?.CurrencyCode1;
    reqPayload.Data['DOB'] = beneficiary.DOB;
    reqPayload.Data['BenfNationality'] = beneficiary.BenfNationality;
    reqPayload.Status = false;
    reqPayload.SessionID = sessionId;
    reqPayload.IdType = null;
    dispatch(beneficiaryActions.addBeneficiary(reqPayload));
    setN(true);
  };

  let dataBeneficiary;
  useSelector((state) => (dataBeneficiary = state.addBeneficiary?.data));

  const resetForm = (e) => {
    if (e.target.value === 'Location Code') {
      payloadForAllBanks.Data['CustomerCode'] = userProfile?.CustomerCode;
      payloadForAllBanks.Data['CountryCode'] = payload.Data['CountryCode'];
      payloadForAllBanks.Data['CurrCode'] = payload.Data['CurrencyCode'];
      payloadForAllBanks.Data['ServCode'] = beneficiary.SERVCODE;
      dispatch(beneficiaryActions.getAllBanks(payloadForAllBanks));
    }
    bankList = null;
    branchList = null;
    setBankName('Select Bank Name');
    setBranchName('Select Branch Name');
    setIncagent('Select Agent');
    setInccodeType('Select Code Type');
    setInccodeTypeID('');
    setBeneficiary((beneficiary) => ({
      ...beneficiary,
      errorMsg: '',
      BenfBranch: '',
      BenfBank: '',
      BenFirstName: '',
      BenLastName: '',
      BenfMName: '',
      BenfMobileNo: '',
      BenfAddr1: '',
      BenfAddr2: '',
      BenfAddr3: '',
      CONTCODE: '',
      BankName: '',
      BranchName: '',
      AccountNo: '',
    }));
  };

  return (
    <div className={styles.pageRight}>
      <h2>{Label.Addbeneficiary.heading}</h2>
      <form name="beneficiary" onSubmit={handleSubmit} autoComplete="none">
        <div className={styles.formGroup}>
          <Dropdown
            type="button"
            styles={styles}
            handleChange={handleChange}
            name="Country"
            list={countryList}
            data={incCountry}
            value={country}
            selection={setStyleCountry}
            action={selectCountryName}
            submitted={submitted}
          />
          {popupOk || (submitted && incCountry == 'Select Country' && <div className={styles.LoginPage__error}>Country is required</div>)}
        </div>
        <div className={styles.formGroup}>
          <Dropdown
            type="button"
            styles={styles}
            handleChange={handleChange}
            name="Currency"
            disabled={!payload.Data['CountryCode']}
            list={currencyList}
            data={incCurrency}
            value={currency}
            selection={setStyleCurrency}
            action={selectCurrencyName}
            submitted={submitted}
          />
          {popupOk || (submitted && incCurrency == 'Select Currency' && <div className={styles.LoginPage__error}> Currency is required</div>)}
        </div>
        <div className={styles.formGroup}>
          <Dropdown
            type="button"
            styles={styles}
            disabled={!payload.Data['CurrencyCode']}
            handleChange={handleChange}
            name="Service"
            list={servicesList}
            data={incservices}
            value={services}
            selection={setStyleServices}
            action={selectServicesName}
            submitted={submitted}
          />
          {popupOk || (submitted && incservices == 'Select Service' && <div className={styles.LoginPage__error}> Service is required</div>)}
        </div>
        {incservices == 'BANK TRANSFER' || incservices == 'WALLET TRANSFER' ? (
          ''
        ) : (
          <div className={styles.formGroup}>
            <Dropdown
              type="button"
              styles={styles}
              disabled={incservices === 'Select Service'}
              handleChange={handleChange}
              name="Provider"
              list={serviceProviderList}
              data={incServiceProvider}
              value={serviceProvider}
              selection={setStyleServiceProvider}
              action={selectServiceProvider}
              submitted={submitted}
            />
            {popupOk ||
              (submitted && incServiceProvider == 'Service Provider' && <div className={styles.LoginPage__error}>Service Provider is required</div>)}
          </div>
        )}
        {incservices == 'BANK TRANSFER' || incservices == 'WALLET TRANSFER' ? (
          ''
        ) : (
          <div className={styles.formGroup}>
            <Dropdown
              type="button"
              styles={styles}
              disabled={incServiceProvider === 'Service Provider'}
              handleChange={handleChange}
              name="Agent"
              list={agentList}
              data={incagent}
              value={getAgentDetails}
              selection={setStyleAgent}
              action={selectAgentName}
              submitted={submitted}
            />
            {popupOk || (submitted && incagent == 'Select Agent' && <div className={styles.LoginPage__error}>Agent is required</div>)}
          </div>
        )}
        {incservices == 'WALLET TRANSFER' || incservices == 'CASH PICK UP' ? (
          ''
        ) : (
          <div className={styles.formGroup}>
            <div className={styles.formGroup__radio}>
              <div className={styles.formGroup__radioButton}>
                <input
                  type="radio"
                  onChange={(e) => resetForm(e)}
                  checked={bankOption == 'Bank Code'}
                  disabled={incservices !== 'BANK TRANSFER'}
                  name="code"
                  value="Bank Code"
                  onClick={(e) => setBankOption('Bank Code')}
                />
                <label>
                  <span style={incservices !== 'BANK TRANSFER' ? { background: '#dedada', cursor: 'not-allowed' } : {}}>
                    <img src={checkBlc} alt="" />
                  </span>
                </label>
                Enter Bank code
              </div>
              <div className={styles.formGroup__radioButton}>
                <input
                  type="radio"
                  disabled={incservices !== 'BANK TRANSFER'}
                  checked={bankOption == 'Location Code'}
                  onChange={(e) => resetForm(e)}
                  name="code"
                  value="Location Code"
                  onClick={(e) => setBankOption('Location Code')}
                />
                <label>
                  <span style={incservices !== 'BANK TRANSFER' ? { background: '#dedada', cursor: 'not-allowed' } : {}}>
                    <img src={checkBlc} alt="" />
                  </span>
                </label>
                Enter Location
              </div>
            </div>
          </div>
        )}

        {incservices == 'WALLET TRANSFER' || incservices == 'CASH PICK UP' || bankOption != 'Bank Code' ? (
          ''
        ) : (
          <div className={styles.formGroup}>
            <Dropdown
              type="button"
              styles={styles}
              handleChange={handleChange}
              name="Code Type"
              list={typeDetailsList}
              data={inccodeType}
              value={typeDetails}
              selection={setStylecodeType}
              action={selectCodeType}
              submitted={submitted}
            />
            {popupOk || (submitted && inccodeType == 'Select Code Type' && <div className={styles.LoginPage__error}> Code Type is required</div>)}
          </div>
        )}
        {incservices == 'WALLET TRANSFER' || incservices == 'CASH PICK UP' || bankOption != 'Bank Code' ? (
          ''
        ) : (
          <div className={styles.formGroup + ' ' + styles.searchIcon}>
            <input
              type="text"
              placeholder="Enter Code"
              name="CONTCODE"
              value={beneficiary.CONTCODE}
              autoComplete="none"
              onBlur={() => enterCode()}
              onChange={handleChange}
              className={styles.transform}
            />
            <img src={searchIcon} onClick={() => enterCode()} />
            {popupOk || (submitted && !beneficiary.CONTCODE && <div className={styles.LoginPage__error}>Code is required</div>)}
          </div>
        )}
        {incservices == 'WALLET TRANSFER' || incservices == 'CASH PICK UP' ? (
          ''
        ) : (
          <div className={styles.formGroup}>
            {/* <input type="text" placeholder="Bank" name="BankName" autoComplete="off" value={beneficiary.BankName} onChange={handleChange} /> */}
            <Dropdown
              type="button"
              styles={styles}
              handleChange={handleChange}
              name="BankName"
              list={bankList}
              data={bankName ?? setBankItem}
              value={bank}
              selection={setBank}
              action={selectBankLists}
              submitted={submitted}
              disabled={bankOption === 'Bank Code' || !bankOption}
            />
            {popupOk ||
              (submitted && !bankName && setBankItem == 'Select Bank Name' && <div className={styles.LoginPage__error}>Bank Name is required</div>)}
          </div>
        )}
        {incservices == 'WALLET TRANSFER' || incservices == 'CASH PICK UP' ? (
          ''
        ) : (
          <div className={styles.formGroup}>
            <Dropdown
              type="button"
              styles={styles}
              handleChange={handleChange}
              name="BranchName"
              list={branchList}
              data={branchName ?? setBranchItem}
              value={branch}
              selection={setBranch}
              action={selectBranchLists}
              submitted={submitted}
              disabled={bankOption === 'Bank Code' || !bankOption || (bankName == undefined && setBankItem === 'Select Bank Name')}
            />
            {popupOk ||
              (submitted && !branchName && setBranchItem == 'Select Branch Name' && (
                <div className={styles.LoginPage__error}>Branch Name is required</div>
              ))}
          </div>
        )}
        {(bankOption == 'Bank Code' || bankOption == 'Location Code') && incservices == 'BANK TRANSFER' ? (
          <div className={styles.formGroup}>
            <input
              type="text"
              placeholder="Account Number"
              name="AccountNo"
              autoComplete="none"
              value={beneficiary.AccountNo}
              onChange={handleChange}
            />
            <div className={styles.LoginPage__error}>{beneficiary.errorAccountMsg}</div>
            {popupOk || (submitted && !beneficiary.AccountNo && <div className={styles.LoginPage__error}>Account Number is required</div>)}
          </div>
        ) : (
          ''
        )}
        <div className={styles.formGroup}>
          <input
            type="text"
            placeholder="First Name"
            name="BenFirstName"
            autoComplete="none"
            value={beneficiary.BenFirstName}
            onChange={handleChange}
          />
          <div className={styles.LoginPage__error}>{beneficiary.errorMsgFirstName}</div>
          {popupOk || (submitted && !beneficiary.BenFirstName && <div className={styles.LoginPage__error}>First Name is required</div>)}
        </div>
        <div className={styles.formGroup}>
          <input type="text" placeholder="Last Name" name="BenLastName" autoComplete="none" value={beneficiary.BenLastName} onChange={handleChange} />
          <div className={styles.LoginPage__error}>{beneficiary.errorMsgLastName}</div>
          {popupOk || (submitted && !beneficiary.BenLastName && <div className={styles.LoginPage__error}>Last Name is required</div>)}
        </div>
        <div className={styles.formGroup}>
          <input type="text" placeholder="Address 1" name="BenfAddr1" autoComplete="none" value={beneficiary.BenfAddr1} onChange={handleChange} />
          <div className={styles.LoginPage__error}>{beneficiary.errorAdd1Msg}</div>
          {popupOk || (submitted && !beneficiary.BenfAddr1 && <div className={styles.LoginPage__error}>Address 1 is required</div>)}
        </div>
        <div className={styles.formGroup}>
          <input type="text" placeholder="Address 2" name="BenfAddr2" autoComplete="none" value={beneficiary.BenfAddr2} onChange={handleChange} />
          <div className={styles.LoginPage__error}>{beneficiary.errorAdd2Msg}</div>
          {popupOk || (submitted && !beneficiary.BenfAddr2 && <div className={styles.LoginPage__error}>Address 2 is required</div>)}
        </div>
        <div className={styles.formGroup}>
          <div className={styles.currencyConv}>
            <div>
              <button type="button" style={{ padding: '9px 1px 1px 14px !important' }}>
                {/* <img src={payload.Data['CurrencyFlag']} alt="" /> */}
                {payload.Data['mobileCode'] ? `+${payload.Data['mobileCode']}` : ''}
              </button>
            </div>
            <span></span>
            <input
              type="text"
              // placeholder={`${payload.Data['mobileCode'] ? `+${payload.Data['mobileCode']}` : ''} Mobile Number`}
              placeholder="Mobile Number"
              name="BenfMobileNo"
              autoComplete="none"
              value={beneficiary.BenfMobileNo}
              onChange={handleChange}
              style={{ fontFamily: 'montserratregular' }}
            />
          </div>
          <div className={styles.LoginPage__error}>{beneficiary.errorMsg}</div>
          {popupOk || (submitted && !beneficiary.BenfMobileNo && <div className={styles.LoginPage__error}>Please enter Mobile Number</div>)}
        </div>
        <div className={styles.formGroup}>
          <Dropdown
            type="button"
            styles={styles}
            handleChange={handleChange}
            name="Relationship"
            list={relationList}
            data={setRelationItem}
            value={relation}
            selection={setRelationShip}
            action={selectRelationShip}
            submitted={submitted}
          />
          {/* <div className={styles.dropdown}>
            <button type="button" onClick={() => setRelationShip(!relation)} name="Relationship" onChange={handleChange}>
              {setRelationItem}
            </button>
            <div className={styles.dropdown__droppop + ` ` + `${relation ? styles.show : styles.hide}`}>
              {relationList ? <Items list={relationList} action={selectRelationShip} /> : <h4>Loading...</h4>}
            </div>
          </div>
           */}
          {popupOk ||
            (submitted && setRelationItem == 'Select Relationship' && <div className={styles.LoginPage__error}>Relationship is required</div>)}
          {/* {submitted && <div className={styles.LoginPage__error}>&nbsp;</div>} */}
        </div>
        <input type="submit" className={styles.linkButton} value={Label.Addbeneficiary.buttonLabel} />
        {submitted && dataBeneficiary != null ? (
          <>
            {/* <PopupModel data={dataBeneficiary} /> */}
            {hide && dataBeneficiary.statusCode ? (
              <div className={popUpStyles.dialogue}>
                <div className={popUpStyles.dialogue__wrap}>
                  <img className={popUpStyles.dialogue__close} src={popClose} onClick={hidePopup} />
                  {dataBeneficiary.statusCode == '200' || dataBeneficiary.statusCode == '401' ? (
                    <p>{dataBeneficiary.message}</p>
                  ) : (
                    <p>{dataBeneficiary.message}</p>
                  )}
                  <div className={popUpStyles.dialogue__buttons}>
                    <Link onClick={hidePopup} className={popUpStyles.LoginPage__link}>
                      OK
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </>
        ) : (
          ''
        )}
      </form>
    </div>
  );
};
export default AddBeneficary;
